import { render } from "./PreviewOrderModal.vue?vue&type=template&id=2f8ce924&scoped=true"
import script from "./PreviewOrderModal.vue?vue&type=script&lang=js"
export * from "./PreviewOrderModal.vue?vue&type=script&lang=js"

import "./PreviewOrderModal.vue?vue&type=style&index=0&id=2f8ce924&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f8ce924"]])

export default __exports__